import Axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';

import Button from '~/components/button';
import ContainerFlex from '~/components/containerFlex';
import Input, { MaskTypes } from '~/components/input';
import { IDefaultReturn } from '~/utils/masks';

import { useHistory } from 'react-router-dom';
import { icons } from '~/assets';
import Dialog from '~/components/dialog';
import Loading from '~/components/loading';
import Pagination from '~/components/pagination';
import TableList from '~/components/tableList';
import useApi, { ApiMethod } from '~/hooks/useApi';
import { useUserRole } from '~/hooks/contexts/useUserRole';
import Endpoints from '~/services/endpoints';
import Constants from '~/utils/constants';
import { TitleCategory } from '~/views/ConsultTransaction/TeucardCard/Detail/styles';
import { IListColCampaing } from '../../model';
import * as St from '../../style';
import {
  buildCustomerList,
  buildManualInsertList,
  customerHeader,
  customerHeaderManual,
} from '../models/campaingModels';
import {
  ICustomer,
  IResponseCustomerData,
  IResponseCustomerDataPaginated,
  IResponseDetailsCampaing,
  IResponseDownloadCSV,
} from '../models/interfaceModels';
import {
  handleRemoveSelected,
  onClickCancelCampaing,
  onClickDownloadCSV,
  onClickIncludeCustomerManually,
  searchClientList,
  searchClientListManual,
} from '../services/campaingService';
import { IFormCampaingData } from './campaingData';
import { downloadCampaingDemoXlsx } from '~/views/Files/Upload/utils';
import { FaDownload } from 'react-icons/fa';

const AbaManual: React.FC<{
  form: IFormCampaingData;
  idCampaing: string;
  isPreview: boolean;
  detailsCampaing: IResponseDetailsCampaing | null;
  onCancel: () => void;
}> = ({ form, idCampaing, isPreview, detailsCampaing, onCancel }) => {
  const history = useHistory();
  const [cpf, setCpf] = useState<IDefaultReturn>({} as IDefaultReturn);
  const [nome, setNome] = useState('');
  const [listInsertManual, setListInsertManual] = useState<IListColCampaing[]>(
    [],
  );
  const [listInsertManualBackup, setListInsertManualBackup] = useState<
    IResponseCustomerData[]
  >([]);
  const [infoDialog, setInfoDialog] = useState({
    open: false,
    message: '',
    error: false,
    isGoBack: false,
  });
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState<null | number>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPagesCustomerManual, setTotalPagesCustomerManual] = useState(0);
  const [totalItemsCustomerManual, setTotalItemsCustomerManual] = useState<
    null | number
  >(null);
  const [currentPageCustomerManual, setCurrentPageCustomerManual] = useState(1);
  const [downloadCVSProgress, setDownloadCVSProgress] = useState('');
  const [list, setList] = useState([]);
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [isOpenDialogRemove, setIsOpenDialogRemove] = useState(false);
  const [selectedCustomers, setSelectedCustomers] = useState<any[]>([]);
  const [importingFile, setImportingFile] = useState(false);
  const inputFileRef = useRef<HTMLInputElement>(null);

  const GETBuscaClientesCampanha = useApi<IResponseCustomerDataPaginated>(
    Endpoints.boxBaseClients.getBuscaClientesCampanhaPaginada
      .replace('PARAM_CPF', cpf.unmasked || '')
      .replace('PARAM_NOME', nome || '')
      .replace('PARAM_LIMITE_PAGE', '4')
      .replace('PARAM_PAGE', currentPageCustomerManual.toString()),
    ApiMethod.GET,
  );

  const POSTIncludeCustomersManually = useApi(
    Endpoints.fidelizacao.postIncludeCustomersManually.replace(
      'PARAM_ID_CAMPANHA',
      idCampaing,
    ),
    ApiMethod.POST,
  );

  const GETGainsCustomers = useApi<ICustomer>(
    `${Endpoints.fidelizacao.getGainsCustomers
      .replace('PARAM_ID_CAMPANHA', idCampaing)
      .replace('PARAM_LIMITE_PAGE', '10')
      .replace('PARAM_PAGE', currentPage.toString())}`,
    ApiMethod.GET,
  );

  const GETDownloadGainsCustomers = useApi<IResponseDownloadCSV>(
    Endpoints.fidelizacao.getDownloadGainsCustomers.replace(
      'PARAM_ID_CAMPANHA',
      idCampaing,
    ),
    ApiMethod.GET,
  );

  const DELETECancelCampaing = useApi(
    `${Endpoints.fidelizacao.deleteCampaign.replace(
      'PARAM_ID_CAMPANHA',
      idCampaing,
    )}`,
    ApiMethod.DELETE,
  );

  const POSTRemoveCustomerManually = useApi(
    Endpoints.fidelizacao.postRemoveCustomerManually.replace(
      'PARAM_ID_CAMPANHA',
      idCampaing,
    ),
    ApiMethod.POST,
  );

  const handleImportFile = async (file: File | null) => {
    if (!file) return;

    const extension = file.name.split('.').pop()?.toLowerCase();

    if (!extension || !['xlsx', 'csv'].includes(extension)) {
      setInfoDialog({
        open: true,
        message: 'Selecione um arquivo com extensao .xlsx ou .csv.',
        error: true,
        isGoBack: false,
      });
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileExtension', extension);

    const token = localStorage.getItem(Constants.TOKEN_KEY);
    const tokenBearer = localStorage.getItem(Constants.TOKEN_BEARER);

    setImportingFile(true);

    try {
      const response = await Axios.post(
        Endpoints.fidelizacao.postBulkInsert.replace(
          'PARAM_ID_CAMPANHA',
          idCampaing,
        ),
        formData,
        {
          headers: {
            ...(token ? { apikey: `token ${token}` } : {}),
            ...(tokenBearer ? { Authorization: `Bearer ${tokenBearer}` } : {}),
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      const totalIncluidos = response.data?.totalIncluidos;
      const totalJaExistiam = response.data?.totalJaExistiam;
      const importMessage =
        totalIncluidos !== undefined && totalJaExistiam !== undefined
          ? `Arquivo importado com sucesso. Total incluidos: ${totalIncluidos}. Total que ja existiam: ${totalJaExistiam}.`
          : response.data?.mensagem || 'Arquivo importado com sucesso.';

      setInfoDialog({
        open: true,
        message: importMessage,
        error: false,
        isGoBack: false,
      });

      searchClientList(
        GETGainsCustomers,
        setInfoDialog,
        setTotalPages,
        setTotalItems,
      ).then((searchResponse) => {
        if (searchResponse.status >= 200 && searchResponse.status < 300) {
          buildCustomerList(searchResponse.data, setList);
        }
      });
    } catch (err) {
      setInfoDialog({
        open: true,
        message: err?.response?.data?.mensagem || 'Erro ao importar o arquivo.',
        error: true,
        isGoBack: false,
      });
    } finally {
      setImportingFile(false);
      if (inputFileRef.current) {
        inputFileRef.current.value = '';
      }
    }
  };

  /**
   * Atualiza a lista de clientes inseridos manualmente,
   * alterando o ícone e removendo a ação do cliente que foi inserido.
   * @param item Dados do cliente.
   * @param data Lista completa de clientes.
   */
  const handleListUpdate = async (
    item: IResponseCustomerData,
    data: IResponseCustomerData[],
  ) => {
    data.forEach((customer, index) => {
      if (customer.cpf === item.cpf) {
        data[index].insertedManually = true;
      }
    });
    // setListInsertManualBackup(data);
    await onClickIncludeCustomerManually(
      item,
      POSTIncludeCustomersManually,
      handleListUpdateRemove,
      setInfoDialog,
    ).then((response) => {
      if (response.status >= 200 && response.status < 300) {
        setListInsertManual([]);
        setCurrentPageCustomerManual(1);
        setNome('');
        setCpf({ masked: '', unmasked: '' });
        searchClientList(
          GETGainsCustomers,
          setInfoDialog,
          setTotalPages,
          setTotalItems,
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            buildCustomerList(response.data, setList);
          }
        });
      }
    });
  };

  /**
   * Navega para a tela de inserir cliente manualmente.
   * @param a Evento de clique.
   * @param item Dados do cliente.
   */
  const goToInsert = (
    a?: any,
    item?: IResponseCustomerData,
    data?: IResponseCustomerData[],
    list?: IListColCampaing[],
  ) => {
    handleListUpdate(item, data);
  };

  /**
   * Atualiza a lista de clientes inseridos manualmente,
   * removendo o cliente que ja foi inserido ou que ja estava inserido na campanha,
   * para evitar que o usuario tente inserir mais de uma vez o mesmo cliente.
   * @param item Dados do cliente.
   */
  const handleListUpdateRemove = (item: IResponseCustomerData) => {
    const newList = listInsertManual.filter((i) => i[7].item.cpf !== item.cpf);
    setListInsertManual(newList);
    const newListBackup = listInsertManualBackup.filter(
      (i) => i.cpf !== item.cpf,
    );
    setListInsertManualBackup(newListBackup);
  };

  /**
   * Verifica se algum dos serviços retornou erro.
   * @returns true quando tem algum problema em algum serviço chamado.
   */
  const checkSuccess = () => {
    if (
      GETGainsCustomers.error ||
      GETGainsCustomers.status === 404 ||
      GETGainsCustomers.status === 500 ||
      list.length === 0
    ) {
      return true;
    }

    return false;
  };

  /**
   * Verifica se o usuario tem permissao para ver as opcoes de salvar e cancelar campanha.
   * @returns true quando o usuario tiver permissao e a campanha for de status preview.
   */
  const { hasRole } = useUserRole();

  const showOptionsRule = () =>
    hasRole('ADM') && detailsCampaing?.status === 'PREVIEW';

  const mayEdit = showOptionsRule();

  useEffect(() => {
    if (currentPage >= 1) {
      searchClientList(
        GETGainsCustomers,
        setInfoDialog,
        setTotalPages,
        setTotalItems,
      ).then((response) => {
        if (response.status >= 200 && response.status < 300) {
          buildCustomerList(response.data, setList);
        }
      });
    }
  }, [currentPage]);

  useEffect(() => {
    if (currentPageCustomerManual >= 1 && GETBuscaClientesCampanha.success) {
      searchClientListManual(
        idCampaing,
        GETBuscaClientesCampanha,
        setInfoDialog,
        setTotalPagesCustomerManual,
        setTotalItemsCustomerManual,
      ).then((response) => {
        if (response) {
          buildManualInsertList(response, setListInsertManual, goToInsert);
        }
      });
    }
  }, [currentPageCustomerManual]);

  useEffect(() => {
    if (isPreview) {
      searchClientList(
        GETGainsCustomers,
        setInfoDialog,
        setTotalPages,
        setTotalItems,
      ).then((response) => {
        if (response.status >= 200 && response.status < 300) {
          buildCustomerList(response.data, setList);
        }
      });
    }
  }, [isPreview]);

  return (
    <>
      <Loading
        status={
          GETGainsCustomers.loading ||
          GETDownloadGainsCustomers.loading ||
          GETBuscaClientesCampanha.loading ||
          DELETECancelCampaing.loading ||
          POSTIncludeCustomersManually.loading ||
          POSTRemoveCustomerManually.loading ||
          importingFile
        }
        text={downloadCVSProgress}
      />
      <Dialog
        icon={infoDialog.error ? icons.exclamation : icons.check}
        open={infoDialog?.open}
        title="Detalhes"
        widthInPercent={40}
        positiveLabel="Entendi"
        positiveAction={() => {
          setInfoDialog({
            message: '',
            open: false,
            error: false,
            isGoBack: false,
          });
          if (infoDialog.isGoBack) {
            history.push('/campanha');
          }
        }}
        message={infoDialog?.message}
      />
      <Dialog
        icon={icons.exclamation}
        open={isOpenDialog}
        positiveLabel="Sim"
        negativeLabel="Não"
        positiveAction={async () => {
          setIsOpenDialog(false);
          await onClickCancelCampaing(DELETECancelCampaing, setInfoDialog);
          !!onCancel && onCancel();
        }}
        negativeAction={() => setIsOpenDialog(false)}
        message={'Deseja realmente cancelar a campanha?'}
      />
      <Dialog
        icon={icons.exclamation}
        open={isOpenDialogRemove}
        positiveLabel="Sim"
        negativeLabel="Não"
        positiveAction={() => {
          setIsOpenDialogRemove(false);
          handleRemoveSelected(
            selectedCustomers,
            POSTRemoveCustomerManually,
            setInfoDialog,
          ).then((response) => {
            if (response && response.status >= 200 && response.status < 300) {
              // Atualiza a lista de clientes atingidos pela campanha após a remoção
              searchClientList(
                GETGainsCustomers,
                setInfoDialog,
                setTotalPages,
                setTotalItems,
              ).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                  buildCustomerList(response.data, setList);
                }
              });
            }
          });
        }}
        negativeAction={() => setIsOpenDialogRemove(false)}
        message={'Deseja realmente excluir estes clientes da campanha?'}
      />
      <ContainerFlex row wrap marginTop={20}>
        <St.TitleLevel>Inserir clientes manualmente</St.TitleLevel>
      </ContainerFlex>

      <ContainerFlex
        marginTop={16}
        row
        space
        horizontal
        center
        style={{
          backgroundColor: '#F1F4F6',
          padding: 10,
          borderRadius: 8,
        }}
      >
        <span style={{ fontSize: 18, fontWeight: 600 }}>
          Planilha de exemplo
        </span>
        <Button fitContent onClick={downloadCampaingDemoXlsx} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <FaDownload />
          <span style={{ marginLeft: 10 }}>Download</span>
        </Button>
      </ContainerFlex>

      {mayEdit ? (
        <ContainerFlex row wrap marginTop={30} gap="16">
          <ContainerFlex maxWidth={30}>
            <Input
              label="CPF"
              value={cpf.masked}
              onChange={(e) => setCpf(e.target.value)}
              placeholder="000.000.000-00"
              maxLength={14}
              mask={MaskTypes.CPF}
            />
          </ContainerFlex>

          <ContainerFlex maxWidth={30}>
            <Input
              id="nome"
              name="nome"
              type="text"
              label="Nome"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              placeholder="Nome do cliente"
            />
          </ContainerFlex>

          <ContainerFlex maxWidth={14} style={{ justifyContent: 'flex-end' }}>
            <Button
              borderRadius={10}
              fitContent
              onClick={() => {
                setTotalPagesCustomerManual(0);
                setTotalItemsCustomerManual(0);
                setCurrentPageCustomerManual(1);
                if (
                  !GETBuscaClientesCampanha.success ||
                  currentPageCustomerManual === 1
                ) {
                  searchClientListManual(
                    idCampaing,
                    GETBuscaClientesCampanha,
                    setInfoDialog,
                    setTotalPagesCustomerManual,
                    setTotalItemsCustomerManual,
                  ).then((response) => {
                    if (response) {
                      buildManualInsertList(
                        response,
                        setListInsertManual,
                        goToInsert,
                      );
                    }
                  });
                }
              }}
              disabled={!cpf.masked && !nome}
            >
              <span>Consultar</span>
            </Button>
          </ContainerFlex>

          <ContainerFlex maxWidth={18} style={{ justifyContent: 'flex-end' }}>
            <input
              ref={inputFileRef}
              type="file"
              accept=".xlsx,.csv"
              style={{ display: 'none' }}
              onChange={(event) => {
                handleImportFile(event.target.files?.[0] || null);
              }}
            />
            <Button
              borderRadius={10}
              fitContent
              marginLeft={12}
              onClick={() => inputFileRef.current?.click()}
              disabled={importingFile}
            >
              <span>Importar arquivo</span>
            </Button>
          </ContainerFlex>
        </ContainerFlex>
      ) : null}

      {listInsertManual.length > 0 && (
        <ContainerFlex marginTop={20}>
          <TableList
            customerHeader={customerHeaderManual}
            list={listInsertManual}
          />
          {totalPagesCustomerManual > 1 && (
            <ContainerFlex row horizontal center marginTop={20}>
              <Pagination
                totalPages={totalPagesCustomerManual}
                onCurrentPageChange={(page) => {
                  setCurrentPageCustomerManual(page);
                }}
              />
            </ContainerFlex>
          )}
        </ContainerFlex>
      )}

      <ContainerFlex row wrap marginTop={10}>
        <ContainerFlex>
          <ContainerFlex marginBottom={10}>
            {list.length > 0 && (
              <>
                <ContainerFlex row center space-between marginBottom={30}>
                  <ContainerFlex row end>
                    <Button
                      borderRadius={10}
                      fitContent
                      onClick={() => {
                        onClickDownloadCSV(
                          GETDownloadGainsCustomers,
                          setDownloadCVSProgress,
                          setInfoDialog,
                        );
                      }}
                    >
                      <span>Download</span>
                    </Button>
                    <Button
                      borderRadius={10}
                      fitContent
                      marginLeft={10}
                      onClick={() => {
                        history.push('/campanha');
                      }}
                    >
                      <span>Voltar</span>
                    </Button>
                  </ContainerFlex>
                </ContainerFlex>

                <TableList
                  customerHeader={customerHeader}
                  list={list}
                  checkbox={mayEdit}
                  onSubmitSelectedRows={(rows: any[]) =>
                    setSelectedCustomers(rows)
                  }
                />

                {totalPages > 1 && (
                  <ContainerFlex row horizontal center marginTop={20}>
                    <Pagination
                      totalPages={totalPages}
                      onCurrentPageChange={(page) => {
                        setCurrentPage(page);
                      }}
                    />
                  </ContainerFlex>
                )}

                <ContainerFlex row end marginTop={20}>
                  <Button
                    borderRadius={10}
                    fitContent
                    marginLeft={10}
                    onClick={() => {
                      if (!selectedCustomers || selectedCustomers.length === 0)
                        setInfoDialog({
                          open: true,
                          message:
                            'Selecione ao menos um cliente para remover da campanha.',
                          error: false,
                          isGoBack: false,
                        });
                      setIsOpenDialogRemove(true);
                    }}
                    disabled={selectedCustomers.length === 0 || !mayEdit}
                  >
                    <span>Remover</span>
                  </Button>
                  <Button
                    borderRadius={10}
                    fitContent
                    marginLeft={10}
                    onClick={() => {
                      setIsOpenDialog(true);
                    }}
                    disabled={!mayEdit}
                  >
                    <span>Cancelar</span>
                  </Button>
                  <Button
                    borderRadius={10}
                    fitContent
                    marginLeft={10}
                    onClick={() =>
                      history.push('/define-communication-actions', {
                        idCampaing: idCampaing,
                        dataCampaing: detailsCampaing,
                        templateMensagem: detailsCampaing?.templateMensagem,
                      })
                    }
                    disabled={!mayEdit}
                  >
                    <span>Avançar</span>
                  </Button>
                </ContainerFlex>
              </>
            )}
            {checkSuccess() && (
              <ContainerFlex center marginTop={30}>
                <TitleCategory>Nenhum resultado encontrado</TitleCategory>
              </ContainerFlex>
            )}
          </ContainerFlex>
        </ContainerFlex>
      </ContainerFlex>
    </>
  );
};

export default AbaManual;
